import { render, staticRenderFns } from "./loss-control-performance.vue?vue&type=template&id=099b08f6&scoped=true&"
import script from "./loss-control-performance.vue?vue&type=script&lang=js&"
export * from "./loss-control-performance.vue?vue&type=script&lang=js&"
import style0 from "./loss-control-performance.vue?vue&type=style&index=0&id=099b08f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b08f6",
  null
  
)

export default component.exports